import { formatLegDepartureDate } from "./date";
import { formatCurrencyDisplayFromSymbol } from "./getDenomination";

const DATE_IN_TEXT_REGEX = /\b(\d{1,2}\/\d{1,2}\/\d{2,4})\b/g;
const PRICE_REGEX = /(£|\$|€)\s*([\d,]+(?:\.\d{2})?)(?!\s*(?:GBP|USD|EUR))/gi;

/**
 * Formats currency amounts in HTML/text as symbol + amount + code (e.g. £9,000 GBP).
 * @param {string} text
 * @returns {string}
 */
const formatPricesInText = (text) => {
    if (!text) return text;
    return text.replace(PRICE_REGEX, (_, symbol, amount) => formatCurrencyDisplayFromSymbol(symbol, amount));
};

/**
 * Normalises dd/MM/yyyy (and similar) dates in HTML/text to dd/MM/yy.
 * @param {string} text
 * @returns {string}
 */
const formatDatesInText = (text) => {
    if (!text) return text;
    return text.replace(DATE_IN_TEXT_REGEX, (match) => formatLegDepartureDate(match));
};

/**
 * Applies dashboard date and price formatting to message body HTML.
 * @param {string} text
 * @returns {string}
 */
const formatDashboardText = (text) => formatDatesInText(formatPricesInText(text));

export { formatPricesInText, formatDatesInText, formatDashboardText };
